import { apiClient } from "@/services/api";
import { PublicObjectBrief } from "@/types";

export async function fetchGoalBrief(
  accountId: string
): Promise<PublicObjectBrief | null> {
  return await apiClient<PublicObjectBrief | null>(
    `/api/accounts/${accountId}/goals/briefs`,
    { method: "GET", cache: "no-store" }
  );
}

export async function fetchSignalBrief(
  accountId: string
): Promise<PublicObjectBrief | null> {
  return await apiClient<PublicObjectBrief | null>(
    `/api/accounts/${accountId}/signals/briefs`,
    { method: "GET", cache: "no-store" }
  );
}

export async function fetchFeedbackBrief(
  accountId: string
): Promise<PublicObjectBrief | null> {
  return await apiClient<PublicObjectBrief | null>(
    `/api/accounts/${accountId}/feedbacks/briefs`,
    { method: "GET", cache: "no-store" }
  );
}

export async function fetchTechnologyBrief(
  accountId: string
): Promise<PublicObjectBrief | null> {
  return await apiClient<PublicObjectBrief | null>(
    `/api/accounts/${accountId}/technologies/briefs`,
    { method: "GET", cache: "no-store" }
  );
}

export async function fetchActionItemBrief(
  accountId: string
): Promise<PublicObjectBrief | null> {
  return await apiClient<PublicObjectBrief | null>(
    `/api/accounts/${accountId}/action-items/briefs`,
    { method: "GET", cache: "no-store" }
  );
}
